import { call, put, select, takeEvery } from 'redux-saga/effects'

import { IHateoasLink } from '@store'
import { selectAuthToken } from '@store/auth'
import { IPitchSubmissionComparison, selectComparisonLink } from '@store/submissions'
import {
  fetchPitchComparison,
  fetchPitchComparisonError,
  fetchPitchComparisonSuccess,
} from '@store/submissions/actions/compareSubmission'
import { networkRequest } from '@utils'

export function* handleFetchPitchSubmissionComparison(
  action: ReturnType<typeof fetchPitchComparison>,
) {
  const { submissionId } = action.payload
  try {
    const authToken: string = yield select(selectAuthToken)
    const comparisonLink: IHateoasLink = yield select(selectComparisonLink, submissionId)

    const results: IPitchSubmissionComparison = yield call(
      networkRequest,
      comparisonLink.method,
      comparisonLink.href,
      undefined,
      authToken,
    )

    yield put(fetchPitchComparisonSuccess(submissionId, results))
  } catch (error) {
    yield put(fetchPitchComparisonError(submissionId, error))
  }
}

export function* watchFetchPitchSubmissionComparison() {
  yield takeEvery(fetchPitchComparison.type, handleFetchPitchSubmissionComparison)
}
